class Navigation {

    /**
     * Create a new Navigation
     * @param {HTMLElement} root 
     */
    constructor(root) {
        this.root = root;
        this.root.dataset.originalWidth = root.offsetWidth;

        // Submenu Togglers
        const togglers = Array.from(this.root.querySelectorAll('[data-action="submenu"]'));
        togglers.map(toggler => toggler.addEventListener('click', this.toggleMenu.bind(this, toggler)));

        // Help Menu
        const helpAction = this.root.querySelector('[data-action="help"]');
        const helpMenu = document.querySelector('matterport-help');
        if (helpAction && helpMenu) {
            helpAction.addEventListener('click', (event) => {
                event.preventDefault();
                if (!helpMenu.isOpen) {
                    helpMenu.open();
                }
            });
        }

        // Close when click is outside
        document.addEventListener('click', async (event) => {
            if (this.root.contains(event.target)) {
                return;
            }

            const action = this.root.querySelector('.current [data-action="submenu"]');
            if (!action) {
                return;
            }
            
            const target = this.root.querySelector(action.dataset.target);
            if (target.classList.contains('active')) {
                await this.closeMenu(target, action);
                target.classList.remove('active');
                this.root.classList.remove('highlights', 'events');
            }
        });

        // Close when resize
        window.addEventListener('resize', async (event) => {
            if (!this.root.classList.contains('active')) {
                return;
            }
            
            const action = this.root.querySelector('.current [data-action="submenu"]');
            if (!action) {
                return;
            }
            
            const target = this.root.querySelector(action.dataset.target);
            if (target.classList.contains('active')) {
                await this.closeMenu(target, action);
                target.classList.remove('active');
                this.root.classList.remove('highlights', 'events');
            }
        });
    }

    /**
     * Toggle Menu
     * @param {HTMLElement} action 
     * @param {Event} event 
     */
    async toggleMenu(action, event) {
        const target = this.root.querySelector(action.dataset.target);
        const primaryButton = event.target;
        if (!target) {
            return;
        }
        if (event) {
            event.preventDefault();
        }

        if (primaryButton.classList.contains("navbar-link-back")) {
            primaryButton.classList.remove("navbar-link-back");
            target.classList.remove('highlights', 'events');
            return
        }

        if (target.classList.contains('active')) {
            await this.closeMenu(target, action);
            target.classList.remove('active');
            target.classList.remove('highlights', 'events');
        } else {
            await this.openMenu(target, action);
            target.classList.add('active');
        }
    }

    /**
     * Open Submenu
     * @param {HTMLElement} submenu 
     * @param {HTMLElement} action 
     */
    async openMenu(submenu, action) {
        const [width, height] = this.calculateDimensions(submenu);

        // Toggle Width
        submenu.style.height = `0px`;
        this.root.style.width = `${this.root.offsetWidth > 400 ? this.root.offsetWidth : 400}px`;
        if (window.innerWidth >= 768) {
            await app.wait(10);
            this.root.style.width = `${submenu.scrollWidth > 400 ? submenu.scrollWidth : 400}px`;
            await app.wait(10);
        }

        // Set Active
        this.root.classList.add('active');
        action.parentElement.classList.add('current');

        await app.wait(300);
        console.log(submenu.classList)
        // submenu.style.height = `${height}px`;
        submenu.style.height = `${submenu.firstElementChild.scrollHeight+16}px`
    }

    /**
     * Close Submenu
     * @param {HTMLElement} submenu 
     * @param {HTMLElement} action 
     */
    async closeMenu(submenu, action) {
        submenu.style.height = `0px`;
        await app.wait(300);

        this.root.style.width = `${this.root.dataset.originalWidth}px`;
        this.root.classList.remove('active');
        this.root.classList.remove('highlights');

        action.parentElement.classList.add("width-full");
        action.classList.add("width-full");
        document.querySelector(".navbar").classList.add("fadeout");
        setTimeout(() => {
            action.parentElement.classList.remove('current');
            action.parentElement.classList.remove("width-full");
            action.classList.remove("width-full");
            document.querySelector(".navbar").classList.remove("fadeout");
        }, 600);
    }

    /**
     * HELPER - Calculate Submenu Container Dimensions
     * @param {HTMLElement} submenu 
     */
    calculateDimensions(submenu) {
        const result = [];

        const clone = submenu.cloneNode(true);
        clone.classList.add('active');
        clone.style.height = 'auto';
        clone.style.opacity = '0';
        clone.style.display = 'flex';
        clone.style.overflow = 'visible';
        clone.style.position = 'absolute';
        clone.style.visibility = 'hidden';
        clone.style.transition = 'none';

        submenu.parentElement.insertBefore(clone, submenu);
        result[0] = clone.offsetWidth;
        result[1] = clone.offsetHeight;

        clone.remove();
        return result;
    }

}

export default Navigation;
